"use client";
import React, { createContext, useContext, useState, ReactNode } from 'react';
import { glob } from "@/lib/pariette"
interface ParietteContextType {
  loading: boolean;
  setLoading: (loading: boolean) => void;
  error: any;
  setError: (error: any) => void;
  consoleLoading: boolean;
  setConsoleLoading: (consoleLoading: boolean) => void;
  consoleError: any;
  setConsoleError: (consoleError: any) => void;
  myBasket: any;
  setMyBasket: (myBasket: any) => void;
  locale?: string | null;
  setLocale?: (locale: string | null) => void;
}

const ParietteContext = createContext<ParietteContextType | undefined>(undefined);

export const ParietteProvider = ({ children, initialLocale }: { children: ReactNode; initialLocale?: string | null }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<any>(glob.errors.noError);
  const [consoleLoading, setConsoleLoading] = useState<boolean>(true);
  const [consoleError, setConsoleError] = useState<any>(glob.errors.noError);
  const [myBasket, setMyBasket] = useState<any>(glob.basket.defaultBasket);
  const [locale, setLocale] = useState<string | null | undefined>(initialLocale ?? glob.locale ?? null);

  return (
    <ParietteContext.Provider value={{ loading, setLoading, error, setError, consoleLoading, setConsoleLoading, consoleError, setConsoleError, myBasket, setMyBasket, locale, setLocale }}>
      {children}
    </ParietteContext.Provider>
  );
};

export const useParietteContext = (): ParietteContextType => {
  const context = useContext(ParietteContext);
  if (!context) {
    throw new Error('Pariette context error!');
  }
  return context;
};
